export default __webpack_public_path__ + "static/media/EPFL0.2eb6f54e.png";